'use strict';
import {SystemEvent} from "../../services/system-state/SystemEvent";

{
    var app = angular.module('tf.portfolio.widgets.raPortfolio', [])
        .controller('raPortfolioCtrl', ['$scope', '$localStorage', '$timeout', "systemEventService", function raPortfolioController($scope, $localStorage, $timeout, systemEventService) {

            $scope.widgetContentHeight = 280;
            var chartApi = null;

            $scope.$on('gridster-resized', function () {
                $scope.updateChartHeight();
            });

            $scope.$on('gridster-item-resized-stop', function (widget) {
                $scope.updateChartHeight();
            });

            $scope.$watch('gridsterItem.sizeY', function () {
                $scope.updateChartHeight();
            });

            $scope.riskChartReady = function (scope, elem) {
                chartApi = scope.api;
            };

            $scope.updateChartHeight = function () {
                if ($scope.gridsterItem != null) {
                    $scope.widgetContentHeight = $scope.calculateAvailableWidgetHeight($scope.gridsterItem);
                    $scope.raPorfolioOptions.chart.height = $scope.widgetContentHeight;
                }

                if (chartApi != null) {
                    chartApi.refresh();
                }
            };

            const resizeSub = systemEventService.filter(evt => evt === SystemEvent.VIEW_RESIZE)
                                                .subscribe(() => $scope.updateChartHeight());
            $scope.$on("$destroy", () => resizeSub.unsubscribe());

            var percent = {style: 'percent', maximumFractionDigits: 0};

            function splitScanArray(scanArray) {
                var volUp = [[-1, scanArray[12], 13], [-0.67, scanArray[8], 9], [-0.33, scanArray[4], 5], [0, scanArray[0], 1], [0.33, scanArray[2], 3], [0.67, scanArray[6], 7], [1, scanArray[10], 11]];
                var volDown = [[-1, scanArray[13], 14], [-0.67, scanArray[9], 10], [-0.33, scanArray[5], 6], [0, scanArray[1], 2], [0.33, scanArray[3], 4], [0.67, scanArray[7], 8], [1, scanArray[11], 12]];
                var volUnch = [];

                for (var i = 0; i < volUp.length; i++) {
                    volUnch[i] = [volUp[i][0], (volUp[i][1] + volDown[i][1]) / 2.0];
                }

                volUnch.unshift([-2, scanArray[15], 16]);
                volUnch.push([2, scanArray[14], 15]);

                return {
                    volDown: volDown,
                    volUnch: volUnch,
                    volUp: volUp
                };
            }

            $scope.raPorfolioOptions = {
                chart: {
                    type: 'lineChart',
                    height: $scope.widgetContentHeight,
                    margin: {
                        top: 10,
                        right: 20,
                        bottom: 40,
                        left: 50
                    },
                    duration: 1000,
                    interpolate: 'monotone',
                    clipVoronoi: true,
                    x: function (d) {
                        return d[0];
                    },
                    y: function (d) {
                        return d[1];
                    },
                    useInteractiveGuideline: false,
                    tooltip: {
                        contentGenerator: function (e) {
                            var tooltip = '<h3>';
                            var key = e.series[0].key;

                            switch (e.seriesIndex) {
                                case 0:
                                case 1:
                                    tooltip += key + ' ' + $scope.portfolioScanArrays.vsr.scanPct.toLocaleString(undefined, percent);
                                    break;
                                case 2:
                                    tooltip += key;
                                    break;

                            }

                            tooltip += '</h3>';
                            tooltip += '<table><tbody>';
                            tooltip += '<tr><td class="key">Expected Outcome</td><td class="value">' + $scope.raPorfolioOptions.chart.yAxis.tickFormat(e.point[1]) + '</td>';
                            tooltip += '<tr><td class="key">XJO</td><td class="value">' + $scope.raPorfolioOptions.chart.xAxis.tickFormat(e.point[0]) + '</td>';
                            if (e.point[2]) {
                                tooltip += '<tr><td class="key">Risk Array</td><td class="value">' + e.point[2] + '</td>';
                            }
                            tooltip += '</tbody></table>';
                            return tooltip;
                        }
                    },
                    xAxis: {
                        axisLabel: 'Index Price (spot)',
                        ticks: 14,
                        staggerLabels: true,
                        tickFormat: function (value) {
                            if ($scope.portfolioScanArrays.psr.scanAmount) {
                                return d3.format('0.0f')($scope.portfolioScanArrays.price + ($scope.portfolioScanArrays.psr.scanAmount * value));
                            } else {
                                return d3.format('0.0f')($scope.portfolioScanArrays.price + ($scope.portfolioScanArrays.price * $scope.portfolioScanArrays.psr.scanPct * value));
                            }
                        }
                    },
                    yAxis: {
                        axisLabel: 'Expected Outcome',
                        tickFormat: d3.format('$,.0f'),
                        axisLabelDistance: 30
                    }
                }
            };
            $scope.raData = [{
                "key": "Total Margin Vol  \u25B2",
                "values": []
            },
                {
                    "key": "Total Margin Vol  \u25BC",
                    "values": []
                },
                {
                    "key": "Total Margin Vol Unch",
                    "values": []
                }];
            //

            $scope.$on('margin.whatif.changed', function (event, whatIfMargin) {
                updateData(whatIfMargin);
            });
            if ($scope.lastMarginWhatifChangedData && $scope.lastMarginWhatifChangedData.whatIfMargin) {
                updateData($scope.lastMarginWhatifChangedData.whatIfMargin)
            }

            function updateData(whatIfMargin) {
                var totalScanArray = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

                for (var i = 0; i < whatIfMargin.combinedCommodities.length; i++) {
                    var cc = whatIfMargin.combinedCommodities[i];
                    for (var j = 0; j < cc.riskArray.length; j++) {
                        totalScanArray[j] -= cc.riskArray[j];
                    }
                }

                $scope.portfolioScanArrays = splitScanArray(totalScanArray);
                $scope.portfolioScanArrays.psr = whatIfMargin.psr;
                $scope.portfolioScanArrays.vsr = whatIfMargin.vsr;
                $scope.portfolioScanArrays.price = whatIfMargin.price;

                $scope.raData = $scope.raData.slice();
                $scope.raData[0].values = $scope.portfolioScanArrays.volUp || [];
                $scope.raData[1].values = $scope.portfolioScanArrays.volDown || [];
                $scope.raData[2].values = $scope.portfolioScanArrays.volUnch || [];

                $scope.updateChartHeight()
            }

        }]);
}
